<template>
    <div class="d-flex flex-column h-100">

        <set-wait 
            :showskip='true' 
            :waitmessage.sync='waitMessage'
            :thread='mutableThread' 
            ref='setWait' 
            v-on:skip-wait='setWait = false; $refs.copyDialog.show()'
            v-on:validated-wait='setWait = true; $refs.copyDialog.show()'
            :validateonly='true'
            :showcompleteoption='false'>
        </set-wait>
        <!-- Note that this dialog can do writeback stuff, which needs calling at the end of the chain,
          or can just be a clipboard copy. The "skip" and the "clipboard" style copy, both emit "skip-copy".
          That could be confusing when you see this for the first time, but it does make sense (honestly) -->
        <copy-dialog
            ref='copyDialog'
            :thread='mutableThread'
            :messages='messages'
            :cachedimagedata='cachedimagedata'
            :cacheddocumentdata='cacheddocumentdata'
            v-on:skip-copy='doCopy = false; callPostCopy()'
            v-on:validated-copy='doCopy = true; callPostCopy()'
            v-on:validated-copy-wb='doCopy = false; doSave = true; callPostCopy()'
            :validateonly='true'
            :actiontext.sync='copyText'
            :actiontextrs.sync='copyTextRs'
            :actiontextwb.sync='copyTextWb'
            :showskip='true' 
            :skiptext.sync='skipCopyText'
            :copymessage.sync='copyMessage'
            :showwritebackuser='showWriteBackUser'>
        </copy-dialog>

        <div class="form-inline d-flex justify-content-between message-tabs">
            <div v-if='banner'>{{ banner }}</div>
            <priority-flags v-if='thread && thread.closed_at == null'
            :thread.sync='thread' :thread_id='thread_id'
            class="priority-flags">
            </priority-flags>
            
        </div>

        <form ref="message-create-container" class="message-create flex-grow-1-scroll h-100 w-100">
            <b-tabs>
                <b-tab :title="$t('translations.team')">
                    <div class='m-2 d-flex flex-row align-items-center justify-content-between'>
                        <div class="search-filter">
                            <label class='mr-2 sr-only' for='ug_filter'>{{ capitalise($t("translations.filter")) }}</label>
                            <input class='mr-3 form-control' id='ug_filter' type='text' v-model='ug_filter' :placeholder="this.$t('translations.clinician_group')"><span></span>
                        </div>
                        <div class='d-flex flex-row align-items-center'>
                            <b-form-checkbox v-model="show_all_assignable" name="check-button" switch>
                            <!-- {{ capitalise($t("translations.show_all_clinicians")) }} -->
                            {{ $t("translations.show_available_all_option") }}
                            </b-form-checkbox>
                            <!-- <input class='ml-auto mr-2' id='show_all_clinicians' type='checkbox' v-model='show_all_assignable'>
                            <label for='show_all_clinicians'>{{ capitalise($t("translations.show_all_clinicians")) }}</label> -->
                        </div>
                    </div>
                    <table class="table table-striped bg-white mb-0" style='table-layout: fixed;'>
                        <thead class="thead-light">
                            <!-- <tr style='display:table; width:100%; table-layout:fixed;'> -->
                            <tr>
                                <th scope="col" class="p-1 pl-2 col-8 align-middle small">{{ $t('translations.clinician') }}</th>
                                <!-- @TODO <th scope="col" class="p-0 text-center small">{{ $t('translations.session_times') }}</th> -->
                                <th scope="col" class="p-1 col-3 text-center align-middle small">{{ $t('translations.capacity') }}</th>
                                <th scope="col" class="p-1 col-3 text-center align-middle small">{{ $t('translations.assigned_now') }}</th>
                                <th scope="col" class="p-1 col-3 text-center align-middle small">{{ $t('translations.assigned_today') }}</th>
                                <th scope="col" class="p-1 col-3 text-center align-middle small">{{ $t('translations.completed') }}</th>
                                <th scope="col" class="p-1 col-3 text-center align-middle small"></th>
                            </tr>
                        </thead>
                        <!-- <tbody style='display: block;overflow: auto;max-height: 200px; width: 100%;'> -->
                        <tbody class="quick-assign--tbody">
                            <template v-for='(user, index) in staff'>
                                <tr :key='"u"+index'  v-if='showAssignable(user)' v-on:click.prevent="setAssignee(user.id, null)" :class="{'assign-user-row' : true}">
                                    <th class="p-1 pl-2 col-8 align-middle"><span :class='(!staff[index].available ? " clinician-away" : "")'>{{formatNameCompliant(user) + (!staff[index].available ? " (away)" : "")}}</span></th>
                                    <!-- @TODO <td class="p-1 col-8 text-center">{{user.availability_date[moment().weekday()].availability_time[0].from }} - {{user.availability_date[moment().weekday()].availability_time[0].to }}</td> -->
                                    <td class="p-1 col-3 align-middle text-center">{{getCapacityByDay(user)}}</td>
                                    <td :class="{'p-1 col-3 align-middle text-center': true, /*'bg-warning text-dark': (getAssignedToday(user) >= getCapacityByDay(user))*/}">{{getAssigned(user)}}</td>
                                    <td :class="{'p-1 col-3 align-middle text-center': true}">{{getAssignedToday(user)}}</td>
                                    <td :class="{'p-1 col-3 align-middle text-center': true}">{{getCompletedToday(user)}}</td>
                                    <td class="pl-1 col-3 align-middle text-center"><span v-if="thread && thread.user && user.id == thread.user.provider.preferred_clinician_id" class="icon-gp" v-b-tooltip :title="$t('translations.usual_GP')"></span> <span v-if="thread && user.id == thread.requested_clinician_id" class="icon-star" v-b-tooltip :title="$t('translations.requested_GP')"></span></td>
                                </tr>
                            </template>
                            <template v-for='(group, index) in $root.lookup.user_groups'>
                                <tr :key='"g"+index' v-if='showGroupAssignable(group)' v-on:click.prevent="setAssignee(null, group.id)" class="assign-user-row border-top">
                                    <th class="p-1 pl-2 col-8 align-middle"><span>Group: {{group.name}}</span></th>
                                    <!-- @TODO <td class="p-1 col-7 text-center"></td> -->
                                    <td class="p-1 col-3 align-middle text-center">{{getGroupCapacityByDay(group)}}</td>
                                    <td class="p-1 col-3 align-middle text-center">{{getGroupAssigned(group)}}</td>
                                    <td class="p-1 col-3 align-middle text-center">{{getGroupAssignedToday(group)}}</td>
                                    <td class="p-1 col-3 align-middle text-center">{{getGroupCompletedToday(group)}}</td>
                                    <td class="p-1 col-3 align-middle text-center"></td>
                                    
                                </tr>
                            </template>
                        </tbody>
                    </table>
                </b-tab>
                <b-tab v-if='$root.provider.provider_provider_xref.length' :title="$t('translations.network')">
                    <template v-if='(thread.user.verification_status_id == 3 && thread.user.nhs_number) || (thread && thread.thread_provider_xref && thread.thread_provider_xref.length > 1) || (thread && thread.owner_provider_id != thread.originating_provider_id)'>
                        <div class='m-2 d-flex flex-row align-items-center'>
                            <div class="search-filter">
                                <label class='mr-2 sr-only' for='provider_filter'>{{ capitalise($t("translations.filter")) }}</label>
                                <input class='mr-3 form-control' id='provider_filter' type='text' v-model='provider_filter' :placeholder="this.$t('translations.provider')">
                                <span></span>
                            </div>
                        </div>
                        <table class="table table-striped bg-white mb-0">
                            <thead class="thead-light">
                                <tr style='width:100%'>
                                    <th scope="col" class="p-1 align-middle small">{{ $t('translations.provider') }}</th>
                                    <th scope="col" class="p-1 align-middle text-center small">{{ $t('translations.transferred_now') | capitalise }}</th>
                                    <th scope="col" class="p-1 align-middle text-center small">{{ $t('translations.transferred_today') | capitalise }}</th>
                                    <th scope="col" class="p-1 align-middle text-center small">{{ $t('translations.shared_now') | capitalise }}</th>
                                    <th scope="col" class="p-1 align-middle text-center small">{{ $t('translations.shared_today') | capitalise }}</th>
                                    <th scope="col" class="p-1 align-middle text-center small">&nbsp;</th>
                                    <th scope="col" class="p-1 align-middle text-center small">&nbsp;</th>
                                </tr>
                            </thead>
                            <!-- <tbody style='display: block;overflow: auto;max-height: 200px; width: 100%;'> -->
                            <tbody class="quick-assign--tbody">
                                <template v-for='(xref) in related_providers'>
                                    <template v-if='provider_filter == "" || xref.relation.name.toLowerCase().includes(provider_filter.toLowerCase())'>
                                        <tr :key='xref.relation.id'>
                                            <td class="p-1 align-middle small">{{xref.relation.name}}</td>
                                            <td class="p-1 align-middle text-center small">{{getProviderTransferred(xref.relation.id)}}</td>
                                            <td class="p-1 align-middle text-center small">{{getProviderTransferredToday(xref.relation.id)}}</td>
                                            <td class="p-1 align-middle text-center small">{{getProviderShared(xref.relation.id)}}</td>
                                            <td class="p-1 align-middle text-center small">{{getProviderSharedToday(xref.relation.id)}}</td>
                                            <td v-if="providerIsAssigned(xref.relation_id)" class="align-middle text-center small">
                                                <button v-if='canUnshare(xref.relation_id)' 
                                                    class='btn btn-primary btn-round btn-sm' 
                                                    v-on:click.prevent="unassignProvider(xref.relation)">{{ capitalise($t('translations.stop_share')) }}</button>
                                                <span v-else>{{ capitalise($t('translations.shared')) }}</span>
                                            </td>
                                            <td v-else class="align-middle text-center small">
                                                <button class='btn btn-primary btn-round btn-sm' 
                                                    v-on:click.prevent="startShare(xref.relation)">
                                                        {{ capitalise($t('translations.share')) }}
                                                    </button>
                                            </td>

                                            <td v-if="thread.owner_provider_id == xref.relation.id" class="align-middle text-center small">
                                                {{ capitalise($t('translations.owner')) }}
                                            </td>
                                            <td v-else class="align-middle text-center small">
                                                <button v-if='thread.owner_provider_id == $root.user.provider.id' class='btn btn-primary btn-round btn-sm' 
                                                    v-on:click.prevent="startTransfer(xref.relation);">
                                                    {{ capitalise($t('translations.transfer')) }}
                                                </button>
                                                <span v-else>&nbsp;</span>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </tbody>
                        </table>
                    </template>
                    <div class='alert alert-info m-2' v-else>
                        {{ autobrand('translations.cant_share_non_verified_user_request')}}
                    </div>
                </b-tab>
            </b-tabs>
        </form>
        <div class="mt-1 d-flex flex-row flex-wrap pt-1" style="background: rgba(0, 0, 0, 0.061);">
            <button 
                v-if='thread && thread.thread_provider && (thread.thread_provider.assigned_user_id || thread.thread_provider.assigned_group_id)' 
                class="mb-1 btn btn-info btn-round btn-sm ml-2 align-self-start" 
                v-on:click.prevent="setAssignee(null, null)">{{ capitalise($t('translations.unassign')) }}</button>

            <button class="mb-1 btn btn-outline-primary ml-auto btn-round btn-sm mr-1 align-self-end" v-on:click.prevent="$emit('close')">{{ $t('translations.skip') }}</button>

            <!-- <button class="mb-1 btn btn-outline-primary ml-auto btn-round btn-sm mr-1 align-self-end" v-on:click.prevent="autoAssignSkipped=true; showAssign=false">Skip</button> -->

        </div>
    </div>
</template>


<script>

	export default {
		props: {
            thread: {},
            thread_id: {},
            staff: {},
            messages: {},
            last_item_created_at: {},
            pre_action: {},
            cachedimagedata: {
                default: function () {
                    return []
                },
            },
            cacheddocumentdata: {
                default: function () {
                    return []
                },
            },
            banner: {
                default: "",
            },
		},
		data: function(){
			return {
                show_all_assignable: false,
                showWriteBackUser: false,
                stats: [],
                ug_filter: "",
                provider_filter: "",
                postCopyAction: null,
                postCopyParam: null,
                copyText: 'translations.copy_and_transfer',
                copyTextRs: 'translations.copy_and_transfer_rs',
                copyTextWb: 'translations.transfer',
                skipCopyText: 'translations.skip_and_transfer',
                waitMessage: 'translations.wait_and_transfer_message',
                copyMessage: 'translations.copy_and_transfer_message',
                setWait: false,
                doCopy: false,
                mutableThread: {}

			};
		},
		computed: {
            related_providers() {
                var providers = this.copyNonReactive(this.$root.provider.provider_provider_xref);

                this.thread.thread_provider_xref.forEach((obj) => {
                    if(obj.provider_id != this.$root.provider.id && !providers.find((obj_existing) => {return obj.provider_id == obj_existing.relation_id})) {
                        providers.push({
                            provider_id: this.$root.provider.id, 
                            relation_id: obj.provider_id,
                            relation: obj.provider
                        });
                    }
                });
                return providers;
            },
            user_assignment_today() {
                return this.$root.lookup.user_assignment_today;
            },
            user_completed_today() {
                return this.$root.lookup.user_completed_today;
            },
            user_assignment() {
                return this.$root.lookup.user_assignment;
            },
            group_assignment_today() {
                return this.$root.lookup.group_assignment_today;
            },
            group_completed_today() {
                return this.$root.lookup.group_completed_today;
            },
            group_assignment() {
                return this.$root.lookup.group_assignment;
            },
            transferred_provider_assignment() {
                return this.$root.lookup.transferred_provider_assignment;
            },
            shared_provider_assignment() {
                return this.$root.lookup.shared_provider_assignment;
            },
            transferred_provider_assignment_today() {
                return this.$root.lookup.transferred_provider_assignment_today;
            },
            shared_provider_assignment_today() {
                return this.$root.lookup.shared_provider_assignment_today;
            },
            assignee_name() {
				// @todo Convert these to use find instead.
				if(this.thread && this.thread.thread_provider) {
					if(this.thread.thread_provider.assigned_user) {
						return this.formatName(this.thread.thread_provider.assigned_user);
					}
					else if(this.thread.thread_provider.assigned_group) {
						return this.$t('translations.group') + ": " + this.thread.thread_provider.assigned_group.name;
					}

				}
				return this.$t('translations.unassigned');

			},
		},
		watch: {

		},
		created() {
        },
		beforeDestroy() {
		},
		mounted() {
		},

		methods: {
            showAssignable(user) {
                if(this.ug_filter) {
                    return this.isMemberOfAssignableGroup(user) && (user.forenames + " " + user.surname).toLowerCase().includes(this.ug_filter.toLowerCase());
                }
                if(this.isMemberOfAssignableGroup(user)) {
                    // if(this.staff[index].available || this.show_all_assignable) {
                    if(user.available || this.show_all_assignable) {
                        return true;
                    }
                    if(user.id == this.thread.requested_clinician_id || user.id == this.thread.user.provider.preferred_clinician_id) {
                        return true;
                    }
                }
                return false;
            },
            showGroupAssignable(group) {
                if(this.ug_filter) {
                    return group.group_assignable && group.name.toLowerCase().includes(this.ug_filter.toLowerCase());
                }
                return group.group_assignable;// || this.show_all_assignable;
            },
            providerIsAssigned(provider_id) {
                // console.info(this.thread, this.thread.thread_provider_xref, this.thread.thread_provider_xref.find(obj => {return obj.provider_id == provider_id}));
                // console.info(this.thread.thread_provider_xref);
                return this.thread && this.thread.thread_provider_xref && this.thread.thread_provider_xref.find(obj => {return obj.provider_id == provider_id});
            },
            canUnshare(provider_id) {
                // console.info(this.thread, this.thread.thread_provider_xref, this.thread.thread_provider_xref.find(obj => {return obj.provider_id == provider_id}));
                // console.info(this.thread.thread_provider_xref);

                
                if(this.thread && this.thread.thread_provider_xref) {
                    // Owner cannot be unshared
                    if(this.thread.owner_provider_id == provider_id) {
                        return false;
                    }

                    // Owner can unshare all others
                    if(this.thread.owner_provider_id == this.$root.user.provider.id) {
                        return true;
                    }

                    // Sharer can unshare their own
                    var provider = this.thread.thread_provider_xref.find(obj => {return obj.provider_id == provider_id});
                    if(provider && provider.shared_by == this.$root.provider.id) {
                        return true;
                    }
                }
                return false;
            },
            getCapacityByDay(user) {
                var date = this.moment();
                var day = date.format("YYYY-MM-DD");
                var capacity = 0;
                var weekDay = date.isoWeekday();

                if(Array.isArray(user.availability_date) && user.availability_date.length) {
                    var availability_dates = user.availability_date.filter(obj => {
                        var date_from = null;
                        var date_to = null;

                        if(this.moment(obj.date_from, 'YYYY-MM-DD').isValid()) {
                            date_from = this.moment(obj.date_from, 'YYYY-MM-DD').format("YYYY-MM-DD");
                        }
                        if(this.moment(obj.date_to, 'YYYY-MM-DD').isValid()) {
                            date_to = this.moment(obj.date_to, 'YYYY-MM-DD').format("YYYY-MM-DD");
                        }
                        if(date_from) {
                            if((date_to && date_from <= day && date_to >= day)
                                    || (!date_to && date_from == day)) {
                                return obj.availability_time.find(availability_time => {return this.isCurrentProviderSite(availability_time.site_id)});
                            }
                            //return date_to ? (date_from <= day && date_to >= day) : (date_from == day);
                        }
                        
                        return false;
                    });
                    if(!availability_dates.length) {
                        availability_dates = user.availability_date.filter(obj => {return obj.day_of_week == weekDay});
                    }
                    for(var index in availability_dates) {
                        for(var dIndex in availability_dates[index].availability_time) {
                            if(this.isCurrentProviderSite(availability_dates[index].availability_time[dIndex].site_id)) {
                                capacity += availability_dates[index].availability_time[dIndex].capacity;
                            }
                        }
                    }
                }
                return capacity ? capacity : "";
            },
            getAssigned(user) {
                var assigned = 0;
				if(this.user_assignment && this.user_assignment[user.id]) {
                    for(var index in this.user_assignment[user.id]) {
                        assigned += this.user_assignment[user.id][index];
                    }
                    return assigned;
				}
				return 0;
            },
            getCompletedToday(user) {
                var completed = 0;
				if(this.user_completed_today && this.user_completed_today[user.id]) {
                    for(var index in this.user_completed_today[user.id]) {
                        completed += this.user_completed_today[user.id][index];
                    }
                    return completed;
				}
				return 0;
            },
            getAssignedToday(user) {
                var assigned = 0;
				if(this.user_assignment_today && this.user_assignment_today[user.id]) {
                    for(var index in this.user_assignment_today[user.id]) {
                        assigned += this.user_assignment_today[user.id][index];
                    }
                    return assigned;
				}
				return 0;
            },
            getGroupAssigned(group) {
                var assigned = 0;
				if(this.group_assignment && this.group_assignment[group.id]) {
                    assigned = this.group_assignment[group.id];
				}
				return assigned;
            },
            getProviderTransferred(provider_id) {
                var assigned = 0;
				if(this.transferred_provider_assignment && this.transferred_provider_assignment[provider_id]) {
                    assigned = this.transferred_provider_assignment[provider_id];
				}
				return assigned;
            },
            getProviderShared(provider_id) {
                var shared = 0;
				if(this.shared_provider_assignment && this.shared_provider_assignment[provider_id]) {
                    shared = this.shared_provider_assignment[provider_id];
				}
				return shared;
            },
            getProviderTransferredToday(provider_id) {
                var assigned = 0;
				if(this.transferred_provider_assignment_today && this.transferred_provider_assignment_today[provider_id]) {
                    assigned = this.transferred_provider_assignment_today[provider_id];
				}
				return assigned;
            },
            getProviderSharedToday(provider_id) {
                var shared = 0;
				if(this.shared_provider_assignment_today && this.shared_provider_assignment_today[provider_id]) {
                    shared = this.shared_provider_assignment_today[provider_id];
				}
				return shared;
            },
            getGroupCompletedToday(group) {
                var completed = 0;
				if(this.group_completed_today && this.group_completed_today[group.id]) {
                    completed = this.group_completed_today[group.id];
                }
				return completed;
            },
            getGroupAssignedToday(group) {
                var assigned = 0;
				if(this.group_assignment_today && this.group_assignment_today[group.id]) {
                    assigned = this.group_assignment_today[group.id];
				}
				return assigned;
            },
            getGroupCapacityByDay(group) {
                var date = this.moment();
                var capacity = 0;
                var weekDay = date.isoWeekday();

                if(Array.isArray(group.usergroupcapacity) && group.usergroupcapacity.length) {
                    var usergroupcapacity = group.usergroupcapacity.filter(obj => {return obj.day_of_week == weekDay});
                    
                    for(var index in usergroupcapacity) {
                        capacity += usergroupcapacity[index].capacity;
                    }
                }
                return capacity ? capacity : "";
            },
            
            startShare(provider) {
                this.mutableThread = this.copyNonReactive(this.thread);
                this.showWriteBackUser = false;
                this.action = 'translations.share';
                this.copyText = 'translations.copy_and_share';
                this.copyTextRs = 'translations.copy_and_share_rs';
                this.copyTextWb = 'translations.share';
                this.skipCopyText = 'translations.skip_and_share';
                this.waitMessage = 'translations.wait_and_share_message';
                this.copyMessage = 'translations.copy_and_share_message';

                this.showChainedDialog(this.assignToProvider, provider);

            },
            startTransfer(provider) {
                this.mutableThread = this.copyNonReactive(this.thread);
                if(this.thread.originating_provider_id == this.$root.user.provider.id) {
                    this.showWriteBackUser = true;
                }
                this.action = 'translations.transfer';
                this.copyText = 'translations.copy_and_transfer';
                this.copyTextRs = 'translations.copy_and_transfer_rs';
                this.copyTextWb = 'translations.transfer';
                this.skipCopyText = 'translations.skip_and_transfer';
                this.waitMessage = 'translations.wait_and_transfer_message';
                this.copyMessage = 'translations.copy_and_transfer_message';
                
                this.showChainedDialog(this.setOwner, provider)
            },
            showChainedDialog(onSuccess, param) {
                this.postCopyAction = onSuccess;
                this.postCopyParam = param;
                this.$refs.setWait.show();
            },
            setWaitAction() {
                if(this.setWait) {
                    this.setWait = false;
                    return this.$refs.setWait.set();
                }
                else {
                    return Promise.resolve();
                }
            },
            doCopyAction() {
                if(this.doCopy) {
                    this.doCopy = false;
                    return this.$refs.copyDialog.copyToRecordSystem();
                }
                else {
                    return Promise.resolve();
                }
            },
            callPostCopy() {
                this.postCopyAction(this.postCopyParam).then(() => {
                    this.setWaitAction().then(() => {
                        this.doCopyAction().then(() => {
                           this.$emit("close");
                        });
                    });
                });
            },
            assignToProvider(provider) {
                this.setLoading(true);

                return axios.put(this.$root.apiBase + '/threads/assignProvider/' + this.thread.id, {"provider_id": provider.id}).then((res) => {
                    this.$emit("assigned", [res.data.message]);
                    this.thread.thread_provider_xref = res.data.thread.thread_provider_xref;

                    this.setLoading(false);
                    this.addNotification({type: "success", content: this.autobrand('translations.shared_thread_with') + ' ' + provider.name});
                    // if(!this.doCopy) {
                    //     this.$emit("close");
                    // }

                }).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "assign");
                });
            },
            unassignProvider(provider) {
                this.setLoading(true);

                return axios.put(this.$root.apiBase + '/threads/unassignProvider/' + this.thread.id, {"provider_id": provider.id}).then((res) => {
                    this.$emit("assigned", [res.data.message]);
                    this.thread.thread_provider_xref = res.data.thread.thread_provider_xref;

                    this.setLoading(false);
                    this.addNotification({type: "success", content: this.autobrand('translations.unshared_thread_with') + ' ' + provider.name});
                    if(!this.doCopy) {
                        this.$emit("close");
                    }

                }).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "assign");
                });
            },
            setOwner(provider) {
                this.setLoading(true);

                return axios.put(this.$root.apiBase + '/threads/setOwner/' + this.thread.id, {"provider_id": provider.id, "writeback_user_id": this.mutableThread.thread_provider.writeback_user_id}).then((res) => {
                    this.$emit("assigned", [res.data.message]);
                    this.thread.thread_provider_xref = res.data.thread.thread_provider_xref;
                    this.thread.owner_provider_id = res.data.thread.owner_provider_id;
                    this.setLoading(false);
                    this.addNotification({type: "success", content: this.$t('translations.transferred_ownership_of_thread_to') + ' ' + provider.name});
                    // if(!this.doCopy) {
                    //     this.$emit("close");
                    // }

                }).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "assign");
                });
            },
			setAssignee(user_id, group_id) {
				if(this.thread_id && this.thread && this.thread.thread_provider && (this.thread.thread_provider.assigned_group_id != group_id || this.thread.thread_provider.assigned_user_id != user_id)) {
					this.setLoading(true);

					return axios.put(this.$root.apiBase + '/threads/assign/' + this.thread.id, {"assigned_group_id": group_id, "assigned_user_id": user_id}).then((res) => {
                        this.$emit("assigned", [res.data.message]);
						this.thread.thread_provider.assigned_user_id = user_id;
						this.thread.thread_provider.assigned_group_id = group_id;
						this.thread.thread_provider.assigned_user = res.data.thread.thread_provider.assigned_user;
						this.thread.thread_provider.assigned_group = res.data.thread.thread_provider.assigned_group;

                        this.setLoading(false);
                        if(this.thread.thread_provider.assigned_user_id || this.thread.thread_provider.assigned_group_id) {
                            this.addNotification({type: "success", content: this.autobrand('translations.assigned_thread_to') + ' ' + this.assignee_name});
                        }
                        else {
                            this.addNotification({type: "success", content: this.autobrand('translations.set_thread_as_unassigned')});
                        }
                        this.$emit("close");
					}).catch((error) => {
						this.setLoading(false);
						this.handleError(error, "assign");
					});
                }
                else {
                    this.showAssign=false;
                    return Promise.resolve();
                }

			},
		}
    }
</script>
